module.exports = __webpack_public_path__ + "star_black.117fbe5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/black/star_black.png
// module id = 938
// module chunks = 0